export class ProspectTourPaymentInfo {
    constructor (
        public StripePublishableKey: string = null,
        public HasActivePayment: boolean = false,
    ) { }
}
